import { render, staticRenderFns } from "./stuFoot.vue?vue&type=template&id=dfd23a54&scoped=true&"
import script from "./stuFoot.vue?vue&type=script&lang=js&"
export * from "./stuFoot.vue?vue&type=script&lang=js&"
import style0 from "./stuFoot.vue?vue&type=style&index=0&id=dfd23a54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd23a54",
  null
  
)

export default component.exports